import React from 'react'
import { useState } from 'react'
import ChangeStatusWriteOffActForm from './ChangeStatusWriteOffActForm'
import Status from '../../../UI/status/Status'
import MyModal from '../../../UI/modal/MyModal'

const ChangeStatusWriteOffActButton = ({ writeOffAct, status }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <button
            onClick={e => setOpen(true)}
        >
            <Status
                status={writeOffAct.status} 
            />
        </button>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Зміна статусу акту'}
            disableClickOutside={true}
            content={
                <ChangeStatusWriteOffActForm
                    writeOffActBd={writeOffAct}
                    // userBd={user}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default ChangeStatusWriteOffActButton